import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogActions, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

@Component({
	selector: 'app-tourism-events-copy-confirm-dialog',
	standalone: true,
	imports: [MatDialogTitle, MatDialogActions, MatButtonModule],
	template: `<h1 mat-dialog-title>Czy na pewno chcesz skopiować wydarzenie transportowe?</h1>
		<mat-dialog-actions align="end"
			><button mat-raised-button color="primary" (click)="close(true)">Tak</button
			><button mat-raised-button color="warn" (click)="close(false)">Nie</button></mat-dialog-actions
		>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourismEventsCopyConfirmDialogComponent {
	private readonly matDialogRef = inject(MatDialogRef);

	close(yesno: boolean): void {
		this.matDialogRef.close(yesno);
	}
}
